<template>
  <section>
    <v-btn outlined color="orange" :to="`/elections/${election}`">
      <v-icon left>mdi-arrow-left-circle</v-icon>
      Return to election
    </v-btn>

    <Eligible :election="election" />
  </section>
</template>

<script>
import Eligible from "./includes/Eligible";
export default {
  props: ["election"],

  components: {
    Eligible,
  },
};
</script>
